//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export default angular.module('curalate.shop-tags-metrics', [
  'curalate',
]);
